export default __webpack_public_path__ + "static/media/bag.2375f1ca.png";